import { IWttExclusion } from '../services/generated-report/generated-report.model'

/**
 * The GHG report's disclosure of well-to-tank emissions a period holds but does not count. Mirrors
 * describeWttExclusion in the backend (lib/upstream-policy/upstream-policy.js), which words the
 * same line in the PDF and the audit pack, so all three say the same thing. Null when nothing
 * shows at two decimal places.
 */
export const describeWttExclusion = (exclusion?: IWttExclusion | null): string | null => {
  const tonnes = Number(exclusion?.excludedTco2e)
  if (!exclusion || !Number.isFinite(tonnes) || tonnes < 0.005) return null
  let text = `Well-to-tank emissions of ${tonnes.toFixed(2)} tCO2e are recorded for this period's activity but are not included in the reported totals.`
  if (exclusion.organisationExcludesWtt && !exclusion.periodLocked) {
    text += ' This follows the organisation\'s setting to exclude well-to-tank emissions.'
  }
  return text
}
